// Registry of hand-built chunk rooms, one JSON file per chunk under
// /data/chunks/<district>/<id>.json (see scripts/generate-chunks.mjs for
// how they were authored). Eagerly imported so the registry is available
// synchronously once the module loads.
const chunkModules = import.meta.glob('/data/chunks/**/*.json', { eager: true });

const registry = {};

for (const mod of Object.values(chunkModules)) {
  const def = mod.default ?? mod;
  registry[def.district] ??= {};
  registry[def.district][def.id] = def;
}

export const ChunkLibrary = {
  get(district, id) {
    const chunk = registry[district]?.[id];
    if (!chunk) throw new Error(`[ChunkLibrary] Unknown chunk: ${district}/${id}`);
    return chunk;
  },

  getPool(district, ids) {
    return ids.map((id) => this.get(district, id));
  },

  listDistrict(district) {
    return Object.values(registry[district] ?? {});
  }
};
